module.exports = __webpack_public_path__ + "img/Chat_1.416aee45.svg";